import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import { usePreviewMedia } from '../hooks';

const PhotoGallery: React.FC = () => {
  const photos = usePreviewMedia();
  const [currentIndex, setCurrentIndex] = useState(0);

  if (photos.length === 0) {
    return (
      <Box
        sx={{
          height: 300,
          bgcolor: 'grey.100',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1,
          mb: 3,
        }}
      >
        <PhotoCameraOutlinedIcon
          sx={{ fontSize: 48, color: 'grey.400', mb: 1 }}
        />
        <Typography color="text.secondary">No Photo Available</Typography>
      </Box>
    );
  }

  const photo = photos[currentIndex];
  const src = photo.MEDIA_URL || photo.MED_URL;
  const alt = photo.MEDIA_SHORT_DESC || `Photo ${currentIndex + 1}`;

  return (
    <Box
      sx={{ position: 'relative', mb: 3, borderRadius: 1, overflow: 'hidden' }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: 350,
          objectFit: 'cover',
          display: 'block',
        }}
      />

      {/* Photo count badge */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 8,
          right: 8,
          bgcolor: 'rgba(0,0,0,0.6)',
          color: 'common.white',
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          fontSize: 14,
        }}
      >
        {currentIndex + 1}/{photos.length}
      </Box>

      {/* Nav arrows */}
      {photos.length > 1 && (
        <>
          <IconButton
            onClick={() =>
              setCurrentIndex((i) => (i > 0 ? i - 1 : photos.length - 1))
            }
            sx={{
              position: 'absolute',
              left: 4,
              top: '50%',
              transform: 'translateY(-50%)',
              bgcolor: 'rgba(255,255,255,0.8)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.95)' },
            }}
            size="small"
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            onClick={() =>
              setCurrentIndex((i) => (i < photos.length - 1 ? i + 1 : 0))
            }
            sx={{
              position: 'absolute',
              right: 4,
              top: '50%',
              transform: 'translateY(-50%)',
              bgcolor: 'rgba(255,255,255,0.8)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.95)' },
            }}
            size="small"
          >
            <ChevronRightIcon />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default React.memo(PhotoGallery);
